import { focusOutlineStyle } from '@totallymoney/ui/styles/focus'
import theme from '@totallymoney/ui/theme'
import styled, { css } from 'styled-components'

export const CollapsibleWrapper = styled.div<{ hasFocus: boolean }>`
    border: 1px solid #9a98ab;
    border-radius: 8px;
    background: white;

    ${({ hasFocus }) => (hasFocus ? focusOutlineStyle : '')}
`

export const HeadLineWrapperButton = styled.button`
    border: none;
    font: inherit;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space10} ${theme.space10} ${theme.space10} 16px;
    cursor: pointer;
    text-align: left;
    height: 48px;
    font-weight: 600;
    border-radius: 8px;
    outline: none;

    & > svg {
        padding: ${theme.space10};
        margin-left: ${theme.space10};
        box-sizing: content-box;
        flex-shrink: 0;
    }
`

export const HeadlineTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${theme.space10};

    > h5 {
        white-space: nowrap;
        font-size: 14px;
    }
`

export const SubtitleWrapper = styled.div<{ isOpen: boolean }>`
    transition: opacity 0.3s ease-in-out;
    opacity: ${props => (props.isOpen ? 0 : 1)};
`

export const ContentContainer = styled.div<{ isOpen: boolean }>`
    position: relative;
    background: #fff;
    padding: 0 16px;
    border-radius: 8px;

    overflow: hidden;
    max-height: 0;
    transition: max-height 0.3s ease-out, padding 0.3s ease-out;

    > div > div {
        @media only screen and (max-width: 1001px) {
            padding-right: 0;
        }
    }

    ${props =>
        props.isOpen &&
        css`
            padding: 16px;
            padding-top: 8px;
            padding-bottom: 16px;
            max-height: 750px;
        `}
`

export const ContentWrapper = styled.div<{ isOpen: boolean }>`
    display: flex;
    flex-direction: column;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    width: 100%;

    ${props =>
        props.isOpen &&
        css`
            opacity: 1;
        `}
`

export const ButtonWrapper = styled.div`
    display: flex;
    margin-top: ${theme.space30};

    ${theme.mediaMediumPlus`
        margin-top: 0;
        margin-left: ${theme.space30};
        align-self: flex-end;
    `}
`
